//node modules
import { PatternFormat } from "react-number-format";
import { isValidPhoneNumber } from "react-phone-number-input";
import { useState, useEffect, useCallback } from "react";
import { useForm, Controller } from "react-hook-form";
import toast from "react-hot-toast";
import { Select } from "react-functional-select";
import axios from "axios";
import * as yup from "yup";
import "tw-elements";

//Components
import AcikRizaOnayi from "./AcikRizaOnayi";
import AydinlatmaMetni from "./AydinlatmaMetni";

import "./index.scss";

const CustomFormError = ({ children }) => (
  <span
    style={{
      width: "100%",
      marginTop: "0.25rem",
      fontSize: "0.875em",
      fontWeight: "600",
      color: "#000",
    }}
  >
    {children}
  </span>
);

const ApplicationForm = () => {
  const {
    control,
    handleSubmit,
    register,
    // reset,
    clearErrors,
    // setError,
    // unregister,
    // getValues,
    // setValue,
    // getFieldState,
    watch,
    formState: { errors, isSubmitting },
  } = useForm({
    mode: "all",
  });

  const getFilterOptionString = useCallback(
    (menuOption) => menuOption.data.value.toLocaleLowerCase("tr"),
    []
  );

  const fileSchema = yup
    .mixed()
    .test("fileSize", "The file is too large", (value, context) => {
      return value && value[0] && Math.round(value[0].size / 1024) <= 11264;
    });

  const [uploading, setUploading] = useState(false);
  const [departments, setDepartments] = useState([]);
  const [universities, setUniversites] = useState([]);
  const [cities, setCities] = useState([]);
  const [iclass, setClass] = useState([]);
  const [graduateDates] = useState([
    { value: "2017", label: "2017" },
    { value: "2018", label: "2018" },
    { value: "2019", label: "2019" },
    { value: "2020", label: "2020" },
    { value: "2021", label: "2021" },
    { value: "2022", label: "2022" },
    { value: "2023", label: "2023" },
    { value: "2024", label: "2024" },
    { value: "2025", label: "2025" },
  ]);
  const [departmentPreference] = useState([
    { value: "Mali İşler ", label: "Mali İşler " },
    { value: "Hasar", label: "Hasar" },
    { value: "Bilgi Teknolojileri", label: "Bilgi Teknolojileri" },
    { value: "İş Zekası", label: "İş Zekası" },
    { value: "Proje Yönetimi", label: "Proje Yönetimi" },
    { value: "Teknik", label: "Teknik" },
  ]);

  const fetchUniversites = () => {
    const url = "https://api.webeyondcreative.com/api/form/university";
    const token =
      "eyJhbGciOiJIUzI1NiIsInR5cCI6Ikp6XVCJ9.eyJzdWIiOiIxMjM0NTY3ODkwIi5wibmFtZSI6Ikpva2G4gRG9lIiwiaWF0IjoxNTE2MjM5MDIyfQ.SflKxwRJSMeKKF2QT4fwpMeJf36POk6yJV_adQssw5c";
    axios
      .get(url, {
        headers: {
          "X-Api-Token": token,
        },
      })
      .then((response) => {
        const universities = response.data;
        setUniversites(
          universities.map((university) => ({
            value: university.name,
            label: university.name,
          }))
        );
      });
  };

  const fetchDepartments = () => {
    const url = "https://api.webeyondcreative.com/api/form/department";
    const token =
      "eyJhbGciOiJIUzI1NiIsInR5cCI6Ikp6XVCJ9.eyJzdWIiOiIxMjM0NTY3ODkwIi5wibmFtZSI6Ikpva2G4gRG9lIiwiaWF0IjoxNTE2MjM5MDIyfQ.SflKxwRJSMeKKF2QT4fwpMeJf36POk6yJV_adQssw5c";
    axios
      .get(url, {
        headers: {
          "X-Api-Token": token,
        },
      })
      .then((response) => {
        const departments = response.data;
        setDepartments(
          departments.map((department) => ({
            value: department.name,
            label: department.name,
          }))
        );
      });
  };

  const fetchCities = () => {
    const url = "https://api.webeyondcreative.com/api/form/city";
    const token =
      "eyJhbGciOiJIUzI1NiIsInR5cCI6Ikp6XVCJ9.eyJzdWIiOiIxMjM0NTY3ODkwIi5wibmFtZSI6Ikpva2G4gRG9lIiwiaWF0IjoxNTE2MjM5MDIyfQ.SflKxwRJSMeKKF2QT4fwpMeJf36POk6yJV_adQssw5c";
    axios
      .get(url, {
        headers: {
          "X-Api-Token": token,
        },
      })
      .then((response) => {
        const cities = response.data;
        setCities(
          cities.map((city) => ({
            value: city.name,
            label: city.name,
          }))
        );
      });
  };

  const fetchClasses = () => {
    const url = "https://api.webeyondcreative.com/api/form/class";
    const token =
      "eyJhbGciOiJIUzI1NiIsInR5cCI6Ikp6XVCJ9.eyJzdWIiOiIxMjM0NTY3ODkwIi5wibmFtZSI6Ikpva2G4gRG9lIiwiaWF0IjoxNTE2MjM5MDIyfQ.SflKxwRJSMeKKF2QT4fwpMeJf36POk6yJV_adQssw5c";
    axios
      .get(url, {
        headers: {
          "X-Api-Token": token,
        },
      })
      .then((response) => {
        const classes = response.data;
        setClass(
          classes.map((iclass) => ({
            value: iclass.name,
            label: iclass.name,
          }))
        );
      });
  };

  const submitForm = (data) => {
    setUploading(true);
    axios.defaults.headers["X-Api-Token"] =
      "eyJhbGciOiJIUzI1NiIsInR5cCI6Ikp6XVCJ9.eyJzdWIiOiIxMjM0NTY3ODkwIi5wibmFtZSI6Ikpva2G4gRG9lIiwiaWF0IjoxNTE2MjM5MDIyfQ.SflKxwRJSMeKKF2QT4fwpMeJf36POk6yJV_adQssw5c";
    axios.defaults.headers["Access-Control-Allow-Origin"] = "*";
    axios.defaults.headers["Access-Control-Allow-Credentials"] = "true";

    const formData = new FormData();
    [
      "department",
      "city",
      "university",
      "class",
      "universityGraduatedDate",
      "departmentPreference1",
      "departmentPreference2",
      "departmentPreference3",
    ].forEach((item) => {
      data[item] = data[item].value;
    });

    for (const [key, value] of Object.entries(data)) {
      if (key === "file") {
        formData.append(key, value[0]);
      } else {
        formData.append(key, value);
      }
    }

    axios
      .post(
        "https://api.webeyondcreative.com/api/form/store/we_ray_sigorta_2022",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      )
      .then((response) => {
        if (response.data.exists === "success") {
          setUploading(false);
          document.getElementById("applicationSuc").click();
          //toast.success("Başvurunuz alındı. İlginiz için teşekkürler.");
          // setTimeout(() => {

          // }, 1000);
        } else if (response.data.exists === "db_error") {
          setUploading(false);
          toast.error("Başvurunuz alınamadı!!");
        } else if (response.data.errors.email) {
          setUploading(false);
        }
      })
      .catch((error) => {
        setUploading(false);
        toast.error("Bu e-posta adresi ile daha önce başvuru yapılmıştır!");
        console.log(error);
      });
  };

  useEffect(() => {
    fetchUniversites();
    fetchDepartments();
    fetchClasses();
    fetchCities();
  }, []);

  return (
    <section
      id="application-form"
      className="w-full flex justify-center bg-custom-red pt-28 pb-10"
    >
      <div className="w-4/5 max-w-screen-xl space-y-12">
        <h3 className="text-white text-5xl sm:text-7xl font-bold">
          Başvuru Formu
        </h3>
        <div className="w-full flex justify-center">
          <div className="block shadow-none bg-transparent w-full  md:w-4/5 lg:w-4/6">
            <form onSubmit={handleSubmit(submitForm)}>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="form-group">
                  <input
                    {...register("firstname", { required: "Bu alan zorunlu!" })}
                    type="text"
                    className="error_firstname form-control block rounded-none w-full input-h-47 px-3 py-2 text-sm font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-900 transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-gray-900 focus:outline-none"
                    id="firstname"
                    aria-describedby="firstname"
                    placeholder="Ad"
                  />
                  <CustomFormError>{errors.firstname?.message}</CustomFormError>
                </div>
                <div className="form-group">
                  <input
                    {...register("lastname", { required: "Bu alan zorunlu!" })}
                    type="text"
                    className="form-control block rounded-none w-full input-h-47 px-3 py-2 text-sm font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-900 transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-gray-900 focus:outline-none"
                    id="lastname"
                    aria-describedby="lastname"
                    placeholder="Soyad"
                  />
                  <CustomFormError>{errors.lastname?.message}</CustomFormError>
                </div>
                <Controller
                  control={control}
                  name="phone"
                  rules={{
                    required: "Bu alan zorunlu!",
                    validate: (value) =>
                      isValidPhoneNumber(value) ||
                      "Yanlış telefon numarası formatı!",
                  }}
                  render={({
                    field: { onChange, onBlur, value, name, ref },
                    fieldState: { error },
                  }) => (
                    <div className="form-group">
                      <PatternFormat
                        name={name}
                        getInputRef={ref}
                        onChange={onChange}
                        onBlur={onBlur}
                        value={value}
                        disabled={isSubmitting}
                        className="form-control block rounded-none w-full input-h-47 px-3 py-2 text-sm font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-900 transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-gray-900 focus:outline-none"
                        placeholder="Telefon"
                        format="+90 ### ### ## ##"
                        mask="_"
                      />
                      <CustomFormError>
                        {error && error.message}
                      </CustomFormError>
                    </div>
                  )}
                />
                <div className="form-group">
                  <input
                    {...register("email", {
                      required: "Bu alan zorunlu!",
                      pattern: {
                        value:
                          /\S+@+\gmail.com|\S+@+\hotmail.com|\S+@+\gmx.com|\S+@+\yahoo.com|\S+@+\yandex.com|\S+@+\outlook.com|\S+@+\mail.com|\S+@+\icloud.com|\S+@\S+\.edu.tr/,
                        message: "Yanlış e-posta formatı!",
                      },
                    })}
                    type="email"
                    className="form-control block rounded-none w-full input-h-47 px-3 py-2 text-sm font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-900 transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-gray-900 focus:outline-none"
                    id="email"
                    aria-describedby="email"
                    placeholder="E-Posta"
                  />
                  <CustomFormError>{errors.email?.message}</CustomFormError>
                </div>
                <Controller
                  control={control}
                  name="birthday"
                  rules={{
                    required: "Bu alan zorunlu!",
                  }}
                  render={({
                    field: { onChange, onBlur, value, name, ref },
                    fieldState: { error },
                  }) => (
                    <div className="form-group">
                      <PatternFormat
                        name={name}
                        getInputRef={ref}
                        onChange={onChange}
                        onBlur={onBlur}
                        value={value}
                        disabled={isSubmitting}
                        className="form-control block rounded-none w-full input-h-47 px-3 py-2 text-sm font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-900 transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-gray-900 focus:outline-none"
                        placeholder="Doğum Tarihi (gg/aa/yyyy)"
                        format="##/##/####"
                        mask="_"
                      />
                      <CustomFormError>
                        {error && error.message}
                      </CustomFormError>
                    </div>
                  )}
                />
                <Controller
                  control={control}
                  name="city"
                  rules={{ required: "Bu alan zorunlu!" }}
                  render={({
                    field: { onChange, onBlur, value, name, ref, id },
                    fieldState: { error },
                  }) => (
                    <div className="form-group" aria-invalid={!!error}>
                      <Select
                        id={id}
                        ref={ref}
                        name={name}
                        isClearable
                        options={cities}
                        themeConfig={{
                          control: {
                            backgroundColor: "white",
                            borderRadius: 0,
                            height: "47px",
                          },
                        }}
                        placeholder="Yaşadığı İl"
                        onOptionChange={onChange}
                        onInputBlur={onBlur}
                        value={value}
                        filterIgnoreAccents={true}
                        getFilterOptionString={getFilterOptionString}
                      />
                      <CustomFormError>
                        {error && error.message}
                      </CustomFormError>
                    </div>
                  )}
                />
                <div className="form-group">
                  <input
                    {...register("district", { required: "Bu alan zorunlu!" })}
                    type="text"
                    className="form-control block rounded-none w-full input-h-47 px-3 py-2 text-sm font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-900 transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-gray-900 focus:outline-none"
                    id="district"
                    aria-describedby="district"
                    placeholder="İlçe"
                  />
                  <CustomFormError>{errors.district?.message}</CustomFormError>
                </div>
                <div className="form-group">
                  <input
                    {...register("graduatedHighSchool", {
                      required: "Bu alan zorunlu!",
                    })}
                    type="text"
                    className="form-control block rounded-none w-full input-h-47 px-3 py-2 text-sm font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-900 transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-gray-900 focus:outline-none"
                    id="graduatedHighSchool"
                    aria-describedby="graduatedHighSchool"
                    placeholder="Mezun Olduğu Lise"
                  />
                  <CustomFormError>
                    {errors.graduatedHighSchool?.message}
                  </CustomFormError>
                </div>
                <Controller
                  control={control}
                  name="university"
                  rules={{ required: "Bu alan zorunlu!" }}
                  render={({
                    field: { onChange, onBlur, value, name, ref, id },
                    fieldState: { error },
                  }) => (
                    <div className="form-group" aria-invalid={!!error}>
                      <Select
                        id={id}
                        ref={ref}
                        name={name}
                        isClearable
                        options={universities}
                        themeConfig={{
                          control: {
                            backgroundColor: "white",
                            borderRadius: 0,
                            height: "47px",
                          },
                        }}
                        placeholder="Üniversite"
                        onOptionChange={onChange}
                        onInputBlur={onBlur}
                        value={value}
                        filterIgnoreAccents={true}
                        getFilterOptionString={getFilterOptionString}
                      />
                      <CustomFormError>
                        {error && error.message}
                      </CustomFormError>
                    </div>
                  )}
                />
                <Controller
                  control={control}
                  name="department"
                  rules={{ required: "Bu alan zorunlu!" }}
                  render={({
                    field: { onChange, onBlur, value, name, ref, id },
                    fieldState: { error },
                  }) => (
                    <div className="form-group" aria-invalid={!!error}>
                      <Select
                        id={id}
                        ref={ref}
                        name={name}
                        isClearable
                        options={departments}
                        themeConfig={{
                          control: {
                            backgroundColor: "white",
                            borderRadius: 0,
                            height: "47px",
                          },
                        }}
                        placeholder="Bölüm"
                        onOptionChange={onChange}
                        onInputBlur={onBlur}
                        value={value}
                      />
                      <CustomFormError>
                        {error && error.message}
                      </CustomFormError>
                    </div>
                  )}
                />
                <Controller
                  control={control}
                  name="class"
                  rules={{ required: "Bu alan zorunlu!" }}
                  render={({
                    field: { onChange, onBlur, value, name, ref, id },
                    fieldState: { error },
                  }) => (
                    <div className="form-group" aria-invalid={!!error}>
                      <Select
                        id={id}
                        ref={ref}
                        name={name}
                        isClearable
                        options={iclass}
                        themeConfig={{
                          control: {
                            backgroundColor: "white",
                            borderRadius: 0,
                            height: "47px",
                          },
                        }}
                        placeholder="Sınıf"
                        onOptionChange={onChange}
                        onInputBlur={onBlur}
                        value={value}
                      />
                      <CustomFormError>
                        {error && error.message}
                      </CustomFormError>
                    </div>
                  )}
                />
                <Controller
                  control={control}
                  name="universityGraduatedDate"
                  rules={{ required: "Bu alan zorunlu!" }}
                  render={({
                    field: { onChange, onBlur, value, name, ref, id },
                    fieldState: { error },
                  }) => (
                    <div className="form-group" aria-invalid={!!error}>
                      <Select
                        id={id}
                        ref={ref}
                        name={name}
                        isClearable
                        options={graduateDates}
                        themeConfig={{
                          control: {
                            backgroundColor: "white",
                            borderRadius: 0,
                            height: "47px",
                          },
                        }}
                        placeholder="Üniversite Mezuniyet Tarihi"
                        onOptionChange={onChange}
                        onInputBlur={onBlur}
                        value={value}
                      />
                      <CustomFormError>
                        {error && error.message}
                      </CustomFormError>
                    </div>
                  )}
                />
                <Controller
                  control={control}
                  name="departmentPreference1"
                  rules={{ required: "Bu alan zorunlu!" }}
                  render={({
                    field: { onChange, onBlur, value, name, ref, id },
                    fieldState: { error },
                  }) => (
                    <div className="form-group" aria-invalid={!!error}>
                      <Select
                        id={id}
                        ref={ref}
                        name={name}
                        isClearable
                        options={departmentPreference}
                        themeConfig={{
                          control: {
                            backgroundColor: "white",
                            borderRadius: 0,
                            height: "47px",
                          },
                        }}
                        placeholder="Departman Tercihi - 1"
                        onOptionChange={onChange}
                        onInputBlur={onBlur}
                        value={value}
                      />
                      <CustomFormError>
                        {error && error.message}
                      </CustomFormError>
                    </div>
                  )}
                />
                <Controller
                  control={control}
                  name="departmentPreference2"
                  rules={{ required: "Bu alan zorunlu!" }}
                  render={({
                    field: { onChange, onBlur, value, name, ref, id },
                    fieldState: { error },
                  }) => (
                    <div className="form-group" aria-invalid={!!error}>
                      <Select
                        id={id}
                        ref={ref}
                        name={name}
                        isClearable
                        options={departmentPreference}
                        themeConfig={{
                          control: {
                            backgroundColor: "white",
                            borderRadius: 0,
                            height: "47px",
                          },
                        }}
                        placeholder="Departman Tercihi - 2"
                        onOptionChange={onChange}
                        onInputBlur={onBlur}
                        value={value}
                      />
                      <CustomFormError>
                        {error && error.message}
                      </CustomFormError>
                    </div>
                  )}
                />
                <Controller
                  control={control}
                  name="departmentPreference3"
                  rules={{ required: "Bu alan zorunlu!" }}
                  render={({
                    field: { onChange, onBlur, value, name, ref, id },
                    fieldState: { error },
                  }) => (
                    <div className="form-group" aria-invalid={!!error}>
                      <Select
                        id={id}
                        ref={ref}
                        name={name}
                        isClearable
                        options={departmentPreference}
                        themeConfig={{
                          control: {
                            backgroundColor: "white",
                            borderRadius: 0,
                            height: "47px",
                          },
                        }}
                        placeholder="Departman Tercihi - 3"
                        onOptionChange={onChange}
                        onInputBlur={onBlur}
                        value={value}
                      />
                      <CustomFormError>
                        {error && error.message}
                      </CustomFormError>
                    </div>
                  )}
                />
              </div>

              <div className="form-group form-check mb-6 mt-6">
                <input
                  {...register("aydinlatmaMetni", {
                    required: "Bu alan zorunlu!",
                  })}
                  type="checkbox"
                  className="form-check-input appearance-none h-4 w-4 border border-gray-300 rounded-sm bg-white checked:bg-blue-600 checked:border-blue-600 focus:outline-none transition duration-200 mt-1 align-top bg-no-repeat bg-center bg-contain mr-2 cursor-pointer"
                  id="aydinlatma-metni"
                />
                <label
                  htmlFor="aydinlatma-metni"
                  className="form-check-label inline-block text-white text-xs"
                >
                  Aydınlatma Metni
                </label>
                <p className="text-white pl-6 text-xs">
                  Ray Sigorta tarafından kişisel verilerimin işlenmesi ve aktarılması süreçlerine ilişkin; yöntem, amaç ve hukuki sebepler sayesinde sahip olduğum haklar konusunda bilgilendirildim.{" "}
                  <span
                    data-bs-toggle="modal"
                    data-bs-target="#aydinlatmaMetni"
                    className="text-gray-900 font-bold cursor-pointer"
                  >
                    “Ray Sigorta Aydınlatma Metni”ni okudum, anladım.
                  </span>
                </p>
                <AydinlatmaMetni isChecked={watch("aydinlatmaMetni")} />
              </div>
              <div className="form-group form-check mb-6 mt-6">
                <input
                  {...register("rizaOnayi", {
                    required: "Bu alan zorunlu!",
                  })}
                  type="checkbox"
                  className="form-check-input appearance-none h-4 w-4 border border-gray-300 rounded-sm bg-white checked:bg-blue-600 checked:border-blue-600 focus:outline-none transition duration-200 mt-1 align-top bg-no-repeat bg-center bg-contain mr-2 cursor-pointer"
                  id="riza-onayi"
                />
                <label
                  htmlFor="riza-onayi"
                  className="form-check-label inline-block text-white text-xs"
                >
                  Açık Rıza Onayı
                </label>
                <p className="text-white pl-6 text-xs">
                  Ray Sigorta’ya başvurumun kabulü ve değerlendirilmesi için
                  ekte detayları yer alan kişisel verilerin aktarımı için{" "}
                  <span
                    data-bs-toggle="modal"
                    data-bs-target="#acikRizaOnayi"
                    className="text-gray-900 font-bold cursor-pointer"
                  >
                    Açık Rıza Beyanını okudum, anladım ve “Açık Rıza Veriyorum”.
                  </span>
                </p>
                <AcikRizaOnayi isChecked={watch("rizaOnayi")} />
              </div>
              <div className="form-group">
                <input
                  className="form-control hidden"
                  id="uploadCv"
                  type="file"
                  {...register("file", {
                    required: "This field is required!.",
                    validate: async (value) =>
                      await fileSchema
                        .validate(value, { strict: true })
                        .catch((err) => "File is too big"),
                  })}
                  accept="application/pdf"
                />
              </div>
              <div className="flex flex-row space-x-6">
                <div className="flex flex-col space-y-2">
                  <label
                    className="min-h-12 px-6 py-3.5 bg-white text-black font-medium text-sm leading-tight shadow-md hover:bg-black hover:text-white focus:outline-none focus:ring-0 active:bg-black active:shadow-lg transition duration-150 ease-in-out cursor-pointer"
                    htmlFor="uploadCv"
                  >
                    CV Yükle
                  </label>
                </div>
                <button
                  type="submit"
                  className="px-6 py-3.5 h-min bg-black text-white font-medium text-sm leading-tight shadow-md hover:bg-white hover:text-black focus:outline-none focus:ring-0 active:bg-white active:shadow-lg transition duration-150 ease-in-out"
                  style={{ minWidth: "105px" }}
                >
                  {uploading && (
                    <div
                      class="spinner-border animate-spin inline-block w-4 h-4 border-2 rounded-full"
                      role="status"
                    >
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  )}
                  {!uploading && "Gönder"}
                </button>
              </div>
              <div className="mt-2">
                <div className="flex flex-col">
                  <small color="white">
                    {watch("file") && watch("file.0")
                      ? watch("file.0").name
                      : "CV (max 10 mb)"}
                  </small>
                  {/* <small color="danger">{errors.file?.message}</small> */}
                </div>
              </div>
              {/** Dosya Yükleme ile ilgili hata bloğu  */}
              <button
                id="errorBtn"
                type="button"
                className="hidden"
                data-bs-toggle="modal"
                data-bs-target="#fileError"
              ></button>
              {errors.file?.message &&
                document.getElementById("errorBtn").click()}
              <div
                className="modal fade fixed top-0 left-0 hidden w-full h-full outline-none overflow-x-hidden overflow-y-auto"
                id="fileError"
                tabIndex="-1"
                aria-labelledby="fileErrorTitle"
                aria-modal="true"
                role="dialog"
              >
                <div className="modal-dialog modal-dialog-centered relative w-auto pointer-events-none">
                  <div className="modal-content border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current">
                    <div className="modal-body relative p-4">
                      <p>CV alanı boş bırakılamaz.</p>
                    </div>
                    <div className="modal-footer flex flex-shrink-0 flex-wrap items-center justify-end p-4 py-2 border-t border-gray-200 rounded-b-md">
                      <button
                        onClick={() => {
                          clearErrors("file");
                        }}
                        type="button"
                        className="px-4 py-2 bg-green-500 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-green-600 hover:shadow-lg focus:bg-green-600 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-green-600 active:shadow-lg transition duration-150 ease-in-out cursor-pointer"
                        data-bs-dismiss="modal"
                      >
                        Tamam
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              {/* İşlem başarılı olduğunda çıkacak uyarı mesajı */}
              <button
                id="applicationSuc"
                type="button"
                className="hidden"
                data-bs-toggle="modal"
                data-bs-target="#applicationSuccess"
              ></button>
              <div
                className="modal fade fixed top-0 left-0 hidden w-full h-full outline-none overflow-x-hidden overflow-y-auto"
                id="applicationSuccess"
                tabIndex="-1"
                aria-labelledby="applicationSuccessTitle"
                aria-modal="true"
                role="dialog"
              >
                <div className="modal-dialog modal-dialog-centered relative w-auto pointer-events-none">
                  <div className="modal-content border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current">
                    <div className="modal-body relative p-4">
                      <p>Başvurunuz alınmıştır. İlgiliniz için teşekkürler.</p>
                    </div>
                    <div className="modal-footer flex flex-shrink-0 flex-wrap items-center justify-end p-4 py-2 border-t border-gray-200 rounded-b-md">
                      <button
                        type="button"
                        className="px-4 py-2 bg-green-500 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-green-600 hover:shadow-lg focus:bg-green-600 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-green-600 active:shadow-lg transition duration-150 ease-in-out cursor-pointer"
                        data-bs-dismiss="modal"
                      >
                        Tamam
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ApplicationForm;
